<template>
    <el-button type="success" size="small">
        <slot></slot>
    </el-button>
</template>
